// //анимашка на странице registrator.html

// if ($("#vue-conveyor").length) {
//     new Vue({
//         el: "#vue-conveyor",
//         data: {
//             images: [],
//             count: "",
//         },
//         mounted() {
//             // let dataSrc = $(this.$el).data("src");
//             let imgArray = $(this.$el).data("src").split(";");
//             // console.log(imgArray);
//             this.count = imgArray.length;
//             // this.images = imgArray;
//             // this.mixing();

//             setTimeout(() => {
//                 this.images = imgArray;
//                 this.mixing();
//             }, 2000);
//         },
//         methods: {
//             mixing() {
//                 setTimeout(() => {
//                     this.changeItems();
//                     this.mixing();
//                 }, 3000);
//             },
//             changeItems() {
//                 //удаляет последний элемент и вставляет его в начало массива
//                 let lastItem = this.images.pop();

//                 this.images.unshift(lastItem);

//                 // this.images = _.shuffle(this.images);
//             }
//         }
//     });
// }



// WEBPACK FOOTER //
// ./vue/conveyor.js